<div class="grid">
  <app-kpi-card
    class="kpi-card"
    [value]="data?.events_30m"
    [label]="'charts.titles.kpiTotalEvents30m' | translate"
    [change]="data?.events_30m_delta_pct"
    icon="navigation-2-outline"
    [loading]="isLoading"
  ></app-kpi-card>
  <app-kpi-card
    class="kpi-card"
    [value]="data?.sessions_active_30m"
    [label]="'charts.titles.kpiTotalSessions30m' | translate"
    [change]="data?.sessions_active_30m_delta_pct"
    icon="clock-outline"
    [loading]="isLoading"
  ></app-kpi-card>
</div>
